module.exports = __webpack_public_path__ + "img/jhf_logo.e7073942.svg";